/* global G */

/**
 * Initializes the bluetooth adapter by calling it's init method.
 *
 * @param {Gaia.Web.Application|Gaia.AppModule.Spec} obj the platform Application
 * @returns {(function(*): Promise<*>)|*}
 */
const init = obj => async (args) => {
  const meta = obj?.[G.SESSION]?.[G.STATE]?.[G.META]
      || obj[G.ADAPTER]?.[G.SESSION]?.[G.STATE]?.[G.META]

  if (meta) {
    try {
      await obj[G.ADAPTER][G.BLUETOOTH][G.API].init({})
    } catch (e) {
      console.error('Could not initialize bluetooth adapter', e)
    }
  }

  return args
}

export default init
